module.exports = __webpack_public_path__ + "static/3-1e58a90b4a9fe065c54e10fb1ffbc7b3.jpg";